import { useTranslation } from "@/core/i18n";
import { Button } from "../../../atoms/button/Button";
import ArrowRight from "../../../atoms/icon/icons/arrow_right.svg";

import { PersonalisationAIAdvisorAvatar } from "./PersonalisationAIAdvisorAvatar";
import { PersonalisationScreenLayout } from "./PersonalisationScreenLayout";

interface DidYouKnowScreenProps {
  onNext?: () => void;
  content?: string;
  adonisIdentity: {
    name: string;
    avatarUrl: string;
  };
}

export const DidYouKnowScreen = ({ onNext, content, adonisIdentity }: DidYouKnowScreenProps) => {
  const { t } = useTranslation();
  return (
    <PersonalisationScreenLayout
      header={null}
      footerClassName="flex w-full items-center justify-end px-8 pb-4"
      footer={
        <Button
          style="primary"
          size="large"
          onClick={onNext}
          endIconSVG={ArrowRight}
          iconSize="xsmall"
        >
          {t("common.next")}
        </Button>
      }
      contentClassName="pt-[162px]"
    >
      <PersonalisationAIAdvisorAvatar
        avatarUrl={adonisIdentity.avatarUrl}
        name={adonisIdentity.name}
      />
      <h1 className="whitespace-pre-line font-serif text-[24px] font-normal italic leading-8 tracking-[0.48px] text-[#091F24]">
        {content ?? t("didYouKnowScreen.defaultContent")}
      </h1>
    </PersonalisationScreenLayout>
  );
};
